import { AsYouType } from "libphonenumber-js";

// Formats a phone string progressively as the user types. Pass the raw
// previous value back in and AsYouType handles deletes correctly.
export const formatPhoneAsTyped = (value, country = "US") => {
  if (!value) return "";
  return new AsYouType(country).input(value);
};

// Strip all non-digit characters. Use right before submitting to the
// server, which validates `phone` as digits-only.
export const digitsOnly = (value) => (value || "").toString().replace(/\D/g, "");
